/* eslint-disable react/display-name */
import React from 'react';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

/**
 * @type {class}
 * @desc This view wraps navigation component of multi step manager.
 * @example
 * import { StepsNavigation } from 'module/multiStepManager';
 */
export class StepsNavigation extends React.Component {
    constructor( props ) {
        super( props );
    }

    render() {
        log.debug( 'StepsNavigation.render()' );

        // get context consumer
        const { Consumer } = this.props.context;

        return (
            <Consumer>
                { ( contextValue ) => {

                    // if `view` prop is provided, render the `props.view` component with `StepsNavigation` props and `contextValue` as props
                    if( this.props.view ) {
                        return (
                            <this.props.view
                                { ...this.props }
                                { ...contextValue }
                            />
                        );
                    } else {

                        // if `props.children` is a function, call that to render the view or use `render` prop function
                        return isFunction( this.props.children ) ? this.props.children( contextValue ) : this.props.render( contextValue );
                    }
                } }
            </Consumer>
        );
    }
}

// display name
StepsNavigation.displayName = 'StepsNavigation';

// prop types
StepsNavigation.propTypes = {
    render: PropTypes.func,
    context: PropTypes.any.isRequired,
};

// default props
StepsNavigation.defaultProps = {};
